module.exports = __webpack_public_path__ + "img/box.2dc73a9c.svg";